import { render, staticRenderFns } from "./AssetsRed.vue?vue&type=template&id=10536c0a&scoped=true"
import script from "./AssetsRed.vue?vue&type=script&lang=js"
export * from "./AssetsRed.vue?vue&type=script&lang=js"
import style0 from "./AssetsRed.vue?vue&type=style&index=0&id=10536c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10536c0a",
  null
  
)

export default component.exports